var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScreenUsersDuotoneSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 40,
    viewBox: "0 0 49 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screen-users-duotone-solid",
    clipPath: "url(#clip0_175_4046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44971 5.30002C2.44971 2.59737 4.64705 0.400024 7.34971 0.400024H41.6497C44.3524 0.400024 46.5497 2.59737 46.5497 5.30002V19.4181C45.2481 18.2544 43.5331 17.55 41.6497 17.55V5.30002H7.34971V17.55C5.46627 17.55 3.75127 18.2544 2.44971 19.4181V5.30002Z",
    fill: "url(#paint0_linear_175_4046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44971 5.30002C2.44971 2.59737 4.64705 0.400024 7.34971 0.400024H41.6497C44.3524 0.400024 46.5497 2.59737 46.5497 5.30002V19.4181C45.2481 18.2544 43.5331 17.55 41.6497 17.55V5.30002H7.34971V17.55C5.46627 17.55 3.75127 18.2544 2.44971 19.4181V5.30002Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.35 29.8C8.64956 29.8 9.8959 29.2838 10.8148 28.3648C11.7338 27.4459 12.25 26.1996 12.25 24.9C12.25 23.6004 11.7338 22.3541 10.8148 21.4352C9.8959 20.5162 8.64956 20 7.35 20C6.05044 20 4.80411 20.5162 3.88518 21.4352C2.96625 22.3541 2.45 23.6004 2.45 24.9C2.45 26.1996 2.96625 27.4459 3.88518 28.3648C4.80411 29.2838 6.05044 29.8 7.35 29.8ZM4.9 32.25C2.19734 32.25 0 34.4473 0 37.15C0 38.5052 1.09484 39.6 2.45 39.6H12.25C13.6052 39.6 14.7 38.5052 14.7 37.15C14.7 34.4473 12.5027 32.25 9.8 32.25H4.9ZM24.5 29.8C25.7996 29.8 27.0459 29.2838 27.9648 28.3648C28.8838 27.4459 29.4 26.1996 29.4 24.9C29.4 23.6004 28.8838 22.3541 27.9648 21.4352C27.0459 20.5162 25.7996 20 24.5 20C23.2004 20 21.9541 20.5162 21.0352 21.4352C20.1163 22.3541 19.6 23.6004 19.6 24.9C19.6 26.1996 20.1163 27.4459 21.0352 28.3648C21.9541 29.2838 23.2004 29.8 24.5 29.8ZM22.05 32.25C19.3473 32.25 17.15 34.4473 17.15 37.15C17.15 38.5052 18.2448 39.6 19.6 39.6H29.4C30.7552 39.6 31.85 38.5052 31.85 37.15C31.85 34.4473 29.6527 32.25 26.95 32.25H22.05ZM46.55 24.9C46.55 23.6004 46.0338 22.3541 45.1148 21.4352C44.1959 20.5162 42.9496 20 41.65 20C40.3504 20 39.1041 20.5162 38.1852 21.4352C37.2663 22.3541 36.75 23.6004 36.75 24.9C36.75 26.1996 37.2663 27.4459 38.1852 28.3648C39.1041 29.2838 40.3504 29.8 41.65 29.8C42.9496 29.8 44.1959 29.2838 45.1148 28.3648C46.0338 27.4459 46.55 26.1996 46.55 24.9ZM34.3 37.15C34.3 38.5052 35.3948 39.6 36.75 39.6H46.55C47.9052 39.6 49 38.5052 49 37.15C49 34.4473 46.8027 32.25 44.1 32.25H39.2C36.4973 32.25 34.3 34.4473 34.3 37.15Z",
    fill: "url(#paint1_linear_175_4046)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_4046",
    x1: 2.81239,
    y1: 19.4182,
    x2: 35.2299,
    y2: -11.2007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_175_4046",
    x1: 0.40298,
    y1: 39.6,
    x2: 33.8613,
    y2: 5.52918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_4046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 39.2,
    fill: "white",
    transform: "translate(0 0.400024)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScreenUsersDuotoneSolid);
export default __webpack_public_path__ + "static/media/icon-screen-users-duotone-solid.28f632a88a5914bc905a2c65d4da80ad.svg";
export { ForwardRef as ReactComponent };